import { type RefObject, useEffect } from 'react';

interface UseDrawerBottomOffsetOptions {
  drawerHeight?: number;
  isDrawerOpen?: boolean;
  isToastVisible?: boolean;
  isMobile?: boolean;
}

const useDrawerBottomOffset = (
  ref: RefObject<HTMLElement | null>,
  {
    drawerHeight,
    isDrawerOpen = false,
    isToastVisible = false,
    isMobile = false,
  }: UseDrawerBottomOffsetOptions
) => {
  const baseOffset = isToastVisible ? 100 : 60;

  useEffect(() => {
    if (!ref.current || drawerHeight === undefined) {
      return;
    }

    const isDrawerPushingUp = isMobile && isDrawerOpen;

    if (isDrawerPushingUp || isToastVisible) {
      const offset = isDrawerPushingUp ? drawerHeight + baseOffset : baseOffset;
      ref.current.style.setProperty('--drawer-bottom-offset', `${offset}px`);
    } else {
      ref.current.style.removeProperty('--drawer-bottom-offset');
    }

    return () => {
      ref.current?.style.removeProperty('--drawer-bottom-offset');
    };
  }, [ref, drawerHeight, isDrawerOpen, isToastVisible, isMobile, baseOffset]);
};

export default useDrawerBottomOffset;
